// extracted by mini-css-extract-plugin
module.exports = {"container":"Skills_container__2TqdE","description":"Skills_description__3myYv","infoBlock":"Skills_infoBlock__3I5f_"};